import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import AppLayout from '../../../../layout/components/AppLayout'
import defaultResponseServices from '../defaultResponseServices';
import { useAlert } from '../../../../context/AlertContext';
import { MessageTemplateMinified } from '../components/MessageTemplate/MessageTemplate';
import { ResponseSelector } from '../components/ResponseSelector';

function DefaultResponsePage() {

    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);

    const [defaultResponseList,setDefaultResponseList] = useState(null);
    const [selectedDefault, setSelectedDefault] = useState(null);


    const getDefaultResponseList =() =>{
        defaultResponseServices.getList().then(res=>{
            setDefaultResponseList(res.data);
        }).catch(error=>{
            AppAlert("Something Went Wrong","error")
        })
    }

    useEffect(()=>{
        getDefaultResponseList();
    },[])


    const handleOpen = (_selectedDefault) =>{
        setDialogStatus(true);
        setSelectedDefault(_selectedDefault);
    }

    const handleClose = () =>{
        setDialogStatus(false);
        setSelectedDefault(null);
    }


    const responseSelectCallback = (responseMessage) =>{
		console.log("selected response :", responseMessage);
        let payload = {
            id:selectedDefault.id,
            responseId:responseMessage.id
        }

        defaultResponseServices.save(payload).then(res=>{
            handleClose();
            getDefaultResponseList();
        }).catch(error=>{
            AppAlert("Something Went Wrong","error")
        })

        //setDialogStatus(false);
	}

    return (
        <AppLayout>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1>Default Response Messages</h1>
                    </div>
                </div>
                {defaultResponseList && defaultResponseList.map(defaultResponse=>
                    <div className='card p-3 my-3 ' key={defaultResponse.id}>
                        <div className='row' >
                            <div className='col-md-4'>
                                <h3>{defaultResponse.title}</h3>
                            </div>
                            <div className='col-md-4'>
                                <MessageTemplateMinified message={JSON.parse(defaultResponse.formValues)} messageType={defaultResponse.messageType} />
                            </div>
                            <div className='col-md-4'>
                                <button className='btn btn-outline-primary' onClick={()=>handleOpen(defaultResponse)} >Change</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle>Setup Business Cordinates</DialogTitle>
                <DialogContent>
                    {selectedDefault &&
                    <div className='row mt-3'>
                        <div className='col-md-6'>
                            {selectedDefault.title}
                        </div>
                        <div className='col-md-6'>
                            <div className='ms-2'>
                                <ResponseSelector callBack={responseSelectCallback} />
                            </div>
                        </div>
                    </div>
                    }
                </DialogContent>
            </Dialog>
            
            
        </AppLayout>
    )
}

export default DefaultResponsePage